define('models/composer/forms/BaseQuestion',[
    'lib/knockout',
    'lib/lodash4',
    'util/ObservableModel',
    'models/composer/forms/VisibilityCondition',
    'extensions/i18n/knockout.i18n'
], function (ko, _, ObservableModel, VisibilityCondition) {
    'use strict';

    var BaseQuestionModel = ObservableModel.extend({
        defaults: {
            type: '',
            text: '',
            helpText: '',
            naEnabled: false,
            naSelected: false,
            answer: '',
            comments: '',
            commentsRequired: false,
            isCritical: false,
            isKill: false
        },
        modelProperties: {
            visibilityCondition: VisibilityCondition
        }
    }, function baseQuestionModel_init() {
        var self = this;

        self.modelId = _.uniqueId("question");
        var hasFakeId = false;
        if (!self.id) {
            self.id = self.modelId;
            hasFakeId = true;
        }

        self.index = ko.observable(-1);
        self.questionGroupIndex = ko.observable(-1);

        self.text = self.text.extend({trimmed: null}); //trim whitespace off the text

        if (!self.visibilityCondition) {
            self.visibilityCondition = ko.observable(null);
        }

        self.visibilityCondition.extend({
            validation: {
                validator: function (val) {
                    return !val || val.isValid();
                }
            }
        });

        self.addVisibilityCondition = function() {
            self.visibilityCondition(new VisibilityCondition());
        };

        // Add Knockout-Validation functionality.
        self.text.extend({ required: true });
        ko.validation.group(self, {deep: true, live: true});
        self.errors.showAllMessages(true);

        // Add an unwrap function to remove all unnecessary properties.
        // toIgnore - {object} OR {array}
        //   {object} - An object that maps which properties to ignore based on the type of the model.
        //     The toIgnore key pertaining to this model would be;
        //       'baseQuestion': ['properties', 'to', 'ignore']
        //   OR {array} an array of properties to ignore:
        //       ['properties', 'to', 'ignore']
        self.baseUnwrap = function (toIgnore, options) {
            toIgnore = toIgnore || {};
            options = options || {};
            var typeName = 'baseQuestion';
            var ignore = [
                "errors",
                "isAnyMessageShown",
                "isValid",
                "modelId",
                "unwrap",
                "baseUnwrap",
                "constructor",
                "visibilityCondition",
                "addVisibilityCondition",
                "index",
                "questionGroupIndex"
            ];
            if (options.ignoreFakeIds && hasFakeId) {
                ignore.push('id');
            }
            var passToKids = false;
            if (toIgnore instanceof Array) { // if toIgnore is an array
                ignore = ignore.concat(toIgnore || []);
            } else { // if toIgnore is an object mapping
                ignore = ignore.concat(toIgnore[typeName] || []);
                passToKids = true;
            }
            var data = ObservableModel.unwrap(self, ignore);
            if(self.visibilityCondition && self.visibilityCondition()){
                data.visibilityCondition = self.visibilityCondition().unwrap(passToKids ? toIgnore : undefined, options);
            }
            return data;
        };

        //Can be overwritten by extending classes, like MulitpleChoiceQuestion
        self.unwrap = self.baseUnwrap;
    });

    return BaseQuestionModel;
});
